// extracted by mini-css-extract-plugin
export default {"labeler":"labeler_labeler__UX-Q3","labeler__label":"labeler_labeler__label__Z-ZTG"};